export const BREAKPOINTS = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1024,
  xl: 1200,
  xxl: 1600,
};